import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../../store/api/fbConfig';
import {
  collection, query, where, or, getDocs
} from 'firebase/firestore';

import {
  Container, Typography, List, ListItem, ListItemText,
  CircularProgress, Box, Paper
} from '@mui/material';

const GroupList = () => {
  const [user, setUser] = useState(null);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      if (firebaseUser) loadGroups(firebaseUser);
    });
    return () => unsub();
  }, []);

  const loadGroups = async (currentUser) => {
    setLoading(true);
    const groupRef = collection(db, 'Groups');
    const q = query(
      groupRef,
      or(
        where('owner', '==', currentUser.uid),
        where(`users.${currentUser.uid}`, 'in', ['viewer', 'editor', 'admin'])
      )
    );
    const snap = await getDocs(q);
    const groupList = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setGroups(groupList);
    setLoading(false);
  };

  if (loading) {
    return (
      <Container>
        <Typography variant="h5" gutterBottom>Groups</Typography>
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container>
      <Typography variant="h5" gutterBottom>Groups</Typography>
      {groups.length === 0 ? (
        <Typography>No groups found.</Typography>
      ) : (
        <Paper elevation={1}>
          <List>
            {groups.map((group) => (
              <ListItem
                button
                key={group.id}
                onClick={() => navigate(`/group/${group.id}`)}
              >
                <ListItemText primary={group.name} />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Container>
  );
};

export default GroupList;
